import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  showCategory?: boolean;
}

export default function ComicCard({ comic, showCategory = true }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 色漫屋漫画封面`}
          title={`${comic.title} - 色漫屋在线漫画`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 rounded-md text-xs font-medium text-background-50 whitespace-nowrap ${comic.status === '连载中' ? 'bg-primary-500' : 'bg-foreground-600'}`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-2 left-2 flex items-center gap-1 text-background-50 text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
          <span>{comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.author}</p>
        {showCategory && (
          <div className="flex items-center gap-2 mt-2">
            <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-md text-xs whitespace-nowrap">
              {comic.category}
            </span>
            <span className="flex items-center gap-1 text-xs text-foreground-500">
              <i className="ri-star-fill text-accent-500 w-3 h-3 flex items-center justify-center"></i>
              {comic.rating}
            </span>
          </div>
        )}
      </div>
    </Link>
  );
}